import * as React from 'react';
import { InputHTMLAttributes } from 'react';
import { Radio as MuiRadio } from '@material-ui/core';
import { RadioProps as MuiRadioProps } from '@material-ui/core/Radio';
import { radioStyles } from './radioCssDefs';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

export interface RadioProps extends Pick<MuiRadioProps, Exclude<keyof MuiRadioProps, 'color'>> {
  color?: 'primary';
  'data-testid'?: string;
}

const IconRadio = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5ZM12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5Z"
      fill="currentColor"
    />
  );

const IconRadioChecked = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5ZM12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5Z"
      fill="currentColor"
    />
  );

/**
 * Use `Radio` for rendering a radio button, see stories for more complete examples
 *
 * ```js
 * import { Radio } from 'bento';
 * ```
 * @deprecated Deprecated — use pantry Radio instead.
 * @see https://docs.tocktix.com/pantry?path=/docs/components-radio--docs
 * Migration: Replace Radio with the pantry Radio component.
 */
export const Radio: React.FunctionComponent<React.PropsWithChildren<RadioProps>> = ({
  'data-testid': dataTestId,
  color = 'primary',
  size = 'medium',
  ...rest
}) => {
  return (
    <MuiRadio
      css={radioStyles}
      icon={<IconRadio fontSize={'medium'} />}
      checkedIcon={<IconRadioChecked fontSize={'medium'} />}
      color={color}
      size={size}
      {...rest}
      inputProps={{ 'data-testid': dataTestId } as InputHTMLAttributes<HTMLInputElement>}
    />
  );
};
